import React, { useRef, useEffect, useState, useContext, useMemo, useLayoutEffect } from 'react';
import styles from './GanttChartAll.module.css';
import Procesory from './procesory_btn/Procesory';
import { AppContext } from 'context/AppContext';
import { druk_alert } from 'actions/druk_alert';

const GanttChartAll = ({ stages }) => {
  const chartRef = useRef(null);
  const scrollWrapperRef = useRef(null);

  const [minDate, setMinDate] = useState(null);
  const [etykieta, setEtykieta] = useState("");
  const [maxDate, setMaxDate] = useState(null);
  const [totalChartWidth, setTotalChartWidth] = useState(0);
  const [scaleFactor, setScaleFactor] = useState(0.5);
  
  const contextApp = useContext(AppContext);
  const procesory = contextApp.procesory;
  
  const [nowTime, setNowTime] = useState(new Date()); 
  const [colorFrom, setColorFrom] = useState(4);

  // Stan dla aktywnego zlecenia oraz dynamicznych pozycji Y wierszy
  const [selectedZamowienieId, setSelectedZamowienieId] = useState(null);
  const [rowYPositions, setRowYPositions] = useState({});

  // Grupowanie etapów według procesora
  const groupedStages = useMemo(() => {
    return stages?.reduce((acc, stage) => {
      const { procesor_id } = stage;
      if (!acc[procesor_id]) {
        acc[procesor_id] = [];
      }
      acc[procesor_id].push(stage);
      return acc;
    }, {});
  }, [stages]);

  const processorIds = useMemo(() => Object.keys(groupedStages || {}), [groupedStages]);
  const allStagesList = useMemo(() => Object.values(groupedStages || {}).flat(), [groupedStages]);

  useEffect(() => {
    if (allStagesList && allStagesList.length > 0) {
      const allDates = allStagesList.flatMap(stage => [new Date(stage.start), new Date(stage.end)]);

      if (allDates.length === 0) return;

      const calculatedMinDate = new Date(Math.min(...allDates));
      const calculatedMaxDate = new Date(Math.max(...allDates));

      calculatedMinDate.setHours(calculatedMinDate.getHours() - 1);
      calculatedMaxDate.setHours(calculatedMaxDate.getHours() + 1);

      setMinDate(calculatedMinDate);
      setMaxDate(calculatedMaxDate);

      const totalTimeSpanMinutes = (calculatedMaxDate.getTime() - calculatedMinDate.getTime()) / (1000 * 60);
      setTotalChartWidth(totalTimeSpanMinutes * scaleFactor);
    }
  }, [allStagesList, scaleFactor]);

  // Dynamiczne wyliczenie dokładnego środka Y dla każdego wiersza w DOM
  useLayoutEffect(() => {
    if (!chartRef.current) return;
    
    const rows = chartRef.current.querySelectorAll(`.${styles.processorRow}`);
    const positions = {};

    processorIds.forEach((processorId, index) => {
      if (rows[index]) {
        // Pozycja Y środka danego wiersza względem górnej krawędzi chartRef
        positions[processorId] = rows[index].offsetTop + (rows[index].offsetHeight / 2);
      }
    });

    setRowYPositions(positions);
  }, [processorIds, totalChartWidth, scaleFactor, stages]);

  // Obliczanie szerokości i przesunięcia klocka
  const calculateBarProperties = (start, end) => {
    if (!minDate || !maxDate || !totalChartWidth) {
      return { width: '0px', marginLeft: '0px', leftPx: 0, widthPx: 0 };
    }

    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const stageDurationMs = new Date(end).getTime() - new Date(start).getTime();
    const startOffsetMs = new Date(start).getTime() - minDate.getTime();

    const widthPx = Math.max(0, (stageDurationMs / totalTimeSpanMs) * totalChartWidth);
    const marginLeftPx = Math.max(0, (startOffsetMs / totalTimeSpanMs) * totalChartWidth);

    return {
      width: `${widthPx}px`,
      marginLeft: `${marginLeftPx}px`,
      leftPx: marginLeftPx,
      widthPx: widthPx
    };
  };

  const getColor = (stage, technologiaId, zamowienieId) => {
    let parametr;

    if (colorFrom === 1) { 
      parametr = stage.klient_id;
      let hash = 0;
      const str = String(parametr);
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = Math.abs(hash) % 360; 
      return `hsl(${hue}, 75%, 60%)`;
    }

    if (colorFrom === 2) { 
      const hashString = `${technologiaId}-${zamowienieId}`;
      let hash = 0;
      for (let i = 0; i < hashString.length; i++) {
        hash = hashString.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = (technologiaId * 137.508) % 360;
      const saturation = 70 + (hash % 30);
      const lightness = 50 + (hash % 10);
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }

    if (colorFrom === 3) { 
      parametr = stage.data_spedycji;
      let hash = 0;
      const str = String(parametr);
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      const hue = Math.abs(hash) % 360; 
      return `hsl(${hue}, 75%, 60%)`;
    }

    if (colorFrom === 4) { 

      //                if(druk_alert(stage)){
      //   return `#f00b0b`
      // }

      if(stage.status ==1){
        return `#dde2e7`
      }
     if(stage.status ==2){
        return `#a5cc52 `
      }
         if(stage.status ==3){
        return `#c2b245`
      }



      // parametr = stage.data_spedycji;
      // let hash = 0;
      // const str = String(parametr);
      // for (let i = 0; i < str.length; i++) {
      //   hash = str.charCodeAt(i) + ((hash << 5) - hash);
      // }
      // const hue = Math.abs(hash) % 360; 
      // return `hsl(${hue}, 75%, 60%)`;
    }


  };

  const renderTimelineMarkers = () => {
    if (!minDate || !maxDate || totalChartWidth === 0) return null;

    const markers = [];
    const daysOfWeek = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];
    const interval = 24 * 60 * 60 * 1000;
    
    const startDate = new Date(minDate);
    startDate.setHours(0, 0, 0, 0);

    let currentDate = new Date(startDate);

    while (currentDate <= maxDate) {
      const offsetMs = currentDate.getTime() - minDate.getTime();
      const leftPosition = (offsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

      markers.push(
        <div key={`day-${currentDate.getTime()}`} className={styles.timelineMarker} style={{ left: `${leftPosition + 45}px` }}>
          {daysOfWeek[currentDate.getDay()]} {String(currentDate.getDate()).padStart(2, '0')}/{String(currentDate.getMonth() + 1).padStart(2, '0')}
        </div>
      );

      let hoursToAdd = scaleFactor < 0.3 ? [6, 18] : [0, 3, 6, 9, 12, 15, 18, 21];

      hoursToAdd.forEach(hour => {
        const hourDate = new Date(currentDate);
        hourDate.setHours(hour, 0, 0, 0);

        if (hourDate >= minDate && hourDate <= maxDate) {
          const hourOffsetMs = hourDate.getTime() - minDate.getTime();
          const hourLeftPosition = (hourOffsetMs / (maxDate.getTime() - minDate.getTime())) * totalChartWidth;

          markers.push(
            <div key={`hour-${hourDate.getTime()}`} className={styles.timelineSubMarker} style={{ left: `${hourLeftPosition + 25}px` }}>
              {hour}:00
            </div>
          );
        }
      });

      currentDate.setTime(currentDate.getTime() + interval);
    }
    return markers;
  };

  const calculateNowPosition = () => {
    if (!minDate || !maxDate || totalChartWidth === 0) return 0;
    const now = nowTime.getTime();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const nowOffsetMs = now - minDate.getTime();
    const leftPosition = (nowOffsetMs / totalTimeSpanMs) * totalChartWidth;
    return Math.max(0, Math.min(leftPosition, totalChartWidth));
  };

  const handleScaleChange = (event) => {
    setScaleFactor(parseFloat(event.target.value));
  };

  const handleScrollToNow = () => {
    if (!scrollWrapperRef.current || !minDate || !maxDate || totalChartWidth === 0) return;
    const now = new Date();
    const totalTimeSpanMs = maxDate.getTime() - minDate.getTime();
    const nowOffsetMs = now.getTime() - minDate.getTime();
    const scrollPosition = (nowOffsetMs / totalTimeSpanMs) * totalChartWidth;
    scrollWrapperRef.current.scrollLeft = scrollPosition - (scrollWrapperRef.current.clientWidth / 2);
  };

  // Wyliczanie linii łączących (wyjście z prawej krawędzi -> wejście w lewą krawędź)
  const connectionLines = useMemo(() => {
    if (!selectedZamowienieId || !minDate || !maxDate || !totalChartWidth) return [];

    const matchedStages = [];

    processorIds.forEach((processorId) => {
      const rowStages = groupedStages[processorId] || [];
      const y = rowYPositions[processorId] || 0;

      rowStages.forEach(stage => {
        if (stage.zamowienie_id === selectedZamowienieId) {
          const { leftPx, widthPx } = calculateBarProperties(stage.start, stage.end);

          matchedStages.push({
            startMs: new Date(stage.start).getTime(),
            outPoint: { x: leftPx + widthPx, y },
            inPoint: { x: leftPx, y }
          });
        }
      });
    });

    matchedStages.sort((a, b) => a.startMs - b.startMs);

    const lines = [];
    for (let i = 0; i < matchedStages.length - 1; i++) {
      lines.push({
        from: matchedStages[i].outPoint,
        to: matchedStages[i + 1].inPoint
      });
    }

    return lines;
  }, [selectedZamowienieId, groupedStages, processorIds, rowYPositions, minDate, maxDate, totalChartWidth]);

  return (
    <div className={styles.chartContainer}>
      <div className={styles.header}>
        <div className={styles.btnFormContainer}>
          <button className={styles.btnForm} onClick={() => setColorFrom(2)}>Prace</button>
          <button className={styles.btnForm} onClick={() => setColorFrom(1)}>Klient</button>
          <button className={styles.btnForm} onClick={() => setColorFrom(3)}>Spedycja</button>
          <button className={styles.btnForm} onClick={() => setColorFrom(4)}>Progres</button>
        </div>

        <div className={styles.controls}>
          <span>Powiększenie:</span>
          <input
            type="range"
            min="0.05"
            max="1.0"
            step="0.05"
            value={scaleFactor}
            onChange={handleScaleChange}
          />
          <span style={{ marginLeft: '10px' }}>{scaleFactor.toFixed(2)}x</span>
          <button className={styles.scrollToNowBtn} onClick={handleScrollToNow}>
            Dziś
          </button>
        </div>
      </div>

      <div className={styles.ganttWrapper}>
        {/* LEWA KOLUMNA: NAZWY MASZYN */}
        <div className={styles.stageNamesList}>
          {/* Ukryty element osi czasu - zapewnia dokładne dopasowanie wysokości z CSS */}
          <div 
            className={styles.timeline} 
            style={{ visibility: 'hidden', pointerEvents: 'none' }}
          >
            <div className={styles.timelineMarkersContainer} />
            <div className={styles.timelineLine} />
          </div>
          
          {groupedStages && Object.keys(groupedStages).map(processorId => (
            <div 
              key={`names-group-${processorId}`} 
              className={styles.processorRow}
            >
              <div className={styles.processorNameFixed}>
                {procesory.find(x => x.id == processorId)?.nazwa.substring(0, 13)}
              </div>
            </div>
          ))}
        </div>

        {/* PRAWA KOLUMNA: WYKRES GANTTA */}
        <div className={styles.scrollWrapper} ref={scrollWrapperRef}>
          <div
            ref={chartRef}
            className={styles.ganttChart}
            style={{ width: `${totalChartWidth}px`, position: 'relative' }}
          >
            {/* WARSTWA SVG DLA LINII ŁĄCZĄCYCH */}
            <svg
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 10
              }}
            >
              <defs>
                <marker
                  id="arrowhead"
                  markerWidth="6"
                  markerHeight="6"
                  refX="5"
                  refY="3"
                  orient="auto"
                >
                  <polygon points="0 0, 6 3, 0 6" fill="#ff4d4f" />
                </marker>
              </defs>

              {connectionLines.map((line, index) => {
                const { from, to } = line;
                const deltaX = Math.max(20, Math.abs(to.x - from.x) / 2);
                const pathData = `M ${from.x} ${from.y} C ${from.x + deltaX} ${from.y}, ${to.x - deltaX} ${to.y}, ${to.x} ${to.y}`;

                return (
                  <g key={`connection-${index}`}>
                    <path
                      d={pathData}
                      fill="none"
                      stroke="#ff4d4f"
                      strokeWidth="2.5"
                      strokeDasharray="5 3"
                      markerEnd="url(#arrowhead)"
                    />
                    <circle cx={from.x} cy={from.y} r="3.5" fill="#ff4d4f" />
                  </g>
                );
              })}
            </svg>

            {/* GÓRNA OŚ CZASU */}
            <div className={styles.timeline}>
              <div className={styles.timelineMarkersContainer}>
                {renderTimelineMarkers()}
              </div>
              <div className={styles.timelineLine}></div>
            </div>

            <div 
              className={styles.nowLine} 
              style={{ left: `${calculateNowPosition()}px` }}
            >
              <span className={styles.nowLabel}>TERAZ</span>
            </div>  

            {/* WIERSZE Z KLOCKAMI PRAC */}
            {groupedStages && Object.keys(groupedStages).map(processorId => (
              <div 
                key={`bars-group-${processorId}`} 
                className={styles.processorRow}
              >
                <div className={styles.processorBarsGroup}>
                  {groupedStages[processorId].map(stage => {
                    const { width, marginLeft } = calculateBarProperties(stage.start, stage.end);
                    const barColor = getColor(stage, stage.technologia_id, stage.zamowienie_id);
                    const isSelected = selectedZamowienieId === stage.zamowienie_id;

                    return (
                      <div
                        key={`bar-${stage.global_id}`}
                        className={styles.stageBar}
                        style={{
                          width,
                          marginLeft,
                          backgroundColor: barColor,
                          outline: isSelected ? '2px solid #ff4d4f' : 'none',
                          outlineOffset: '2px',
                          boxShadow: isSelected ? '0 0 8px rgba(255, 77, 79, 0.6)' : 'none',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setSelectedZamowienieId(prev => prev === stage.zamowienie_id ? null : stage.zamowienie_id);
                          setEtykieta(`Start: ${stage.start} - ${stage.end}         Ilość narządów: ${stage.ilosc_narzadow}      Przeloty: ${stage.przeloty} szt.`);
                        }}
                        title={` ${stage.status}  ${stage.name}        ${stage.start} - ${stage.end}   Ilość narządów: ${stage.ilosc_narzadow}      Przeloty: ${stage.przeloty} szt.`}
                      >
                        {stage.progress > 5 && stage.status == 3 && (
                          <div
                            className={styles.progressBar}
                            style={{ width: `${stage.progress}%`, backgroundColor: 'rgba(255,255,255,0.4)' }}
                          ></div>
                        )}
                        {stage.progress > 5 && stage.status == 3 && (
                          <span className={styles.progressText}>
                            {stage.progress}%
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}

            {/* DOLNA OŚ CZASU */}
            <div className={styles.timeline}>
              <div className={styles.timelineMarkersContainer}>
                {renderTimelineMarkers()}
              </div>
              <div className={styles.timelineLine}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GanttChartAll;